// Restore invalid-interest error handling
$(document).on('turbo:load turbo:render validations', (e) => {
    console.log(e.detail.renderMethod)
    let $errorDivs: JQuery = $('.field_with_errors');
    if ($errorDivs.length) {
        // Restore .invalid-interest logic
        let $invalidInterests = $('fieldset.invalid-interest');
        if ( $invalidInterests.length ) {
            $invalidInterests.first().find('div.expandable-form').trigger('lazyReveal').addClass('show');
            $invalidInterests.on('errorField:removed dataRevealed', (e) => {
                let errorFields = $(e.currentTarget).find('.field_with_errors:visible');
                if (!errorFields.length) {
                    // TODO can we add an animation?
                    $(e.currentTarget).removeClass('invalid-interest');
                } else $(e.currentTarget).addClass('invalid-interest');
            });
        }
    }
});

// Delegated event listeners for error field clearing
$(document).on('input change', "div.field_with_errors input:not([type='radio']):not([type='checkbox']):not(.datepicker), div.field_with_errors textarea:not(.datepicker)", function(event) {
    const $field = $(event.target);
    const field_id = $field.attr('id');
    const $labelDiv = $(`label[for='${field_id}']`).closest('div.field_with_errors');
    const $parentDiv = $field.closest('div.field_with_errors');
    const $errorMessageDiv = $parentDiv.next();
    if ($errorMessageDiv.length) {
        $errorMessageDiv.fadeOut(600,() => {
            $labelDiv.removeClass('field_with_errors');
            $parentDiv.removeClass('field_with_errors');
            $parentDiv.closest('fieldset').trigger('errorField:removed');
        });
    } else {
        $labelDiv.removeClass('field_with_errors');
        $parentDiv.removeClass('field_with_errors');
        $parentDiv.closest('fieldset').trigger('errorField:removed');
    }
});

$(document).on('change', "div.field_with_errors select", function(event) {
    const $field = $(event.target);
    const field_id = $field.attr('id');
    const $labelDiv = $(`label[for='${field_id}']`).closest('div.field_with_errors');
    const $parentDiv = $field.closest('div.field_with_errors');
    const $errorMessageDiv = $parentDiv.closest('div.select').next();
    if ($errorMessageDiv.length) {
        $errorMessageDiv.fadeOut(600, () => {
            $errorMessageDiv.css('height', 0);
            $labelDiv.removeClass('field_with_errors');
            $parentDiv.removeClass('field_with_errors');
            $parentDiv.closest('fieldset').trigger('errorField:removed');
        });
    } else {
        $parentDiv.parent().find(".input-error-message").fadeOut(600);
        $labelDiv.removeClass('field_with_errors');
        $parentDiv.removeClass('field_with_errors');
        $parentDiv.closest('fieldset').trigger('errorField:removed');
        if ($field.attr('id') == "lobbyist_registration_subject_matter_1"){
            $($labelDiv[0]).next(".input-error-message").fadeOut(600)
        }
    }
});

$(document).on('change', "div.field_with_errors input[type='radio']", function(event) {
    const $parentDiv = $(event.currentTarget).closest('span').closest('div');
    const $errors = $parentDiv.prev(".field_with_errors");
    const $errorMessageDiv = $parentDiv.find(".input-error-message");
    if ($errorMessageDiv.length) {
        $errorMessageDiv.fadeOut(600, () => {
            $errorMessageDiv.css('height', 0);
            $errors.removeClass('field_with_errors');
            $parentDiv.closest('fieldset').trigger('errorField:removed');
            $parentDiv.children("span").each((i, el) =>{
                let $el = $(el);
                $el.find("div.field_with_errors").removeClass("field_with_errors");
                $parentDiv.closest('fieldset').trigger('errorField:removed');
            });
            if ($parentDiv.hasClass("inline-radio")){
                $parentDiv.find(".field_with_errors").first().removeClass('field_with_errors');
                $parentDiv.closest('fieldset').trigger('errorField:removed');
            }
            else if ($parentDiv.parent().parent().prev().find(".field_with_errors")) {
                $parentDiv.parent().parent().prev().find(".field_with_errors").removeClass("field_with_errors");
                $parentDiv.closest('fieldset').trigger('errorField:removed');
            }
            else if ($parentDiv.parent().prev().find(".field_with_errors")) {
                $parentDiv.parent().prev().find(".field_with_errors").removeClass('field_with_errors');
                $parentDiv.closest('fieldset').trigger('errorField:removed');
            }
        });
    } else {
        $errors.removeClass('field_with_errors') ;
        $parentDiv.closest('fieldset').trigger('errorField:removed');
    }
});

$(document).on('change', "div.field_with_errors input[type='checkbox']", function(event) {
    const $parentDiv = $(event.currentTarget).closest('div');
    const $errorMessage = $parentDiv.next().next();
    if ($errorMessage.attr("class") == "input-error-message"){
        $errorMessage.fadeOut(600);
        $parentDiv.next().removeClass('field_with_errors');
    }
    else{
        let $errorMessageDiv = $parentDiv.parent().parent().prev();
        $errorMessageDiv.find(".input-error-message").fadeOut(600);
        $errorMessageDiv.find(".field_with_errors").removeClass('field_with_errors')
    }
});

// Delegated event handler for .no-label error field clearing
$(document).on('change', 'div.field_with_errors .no-label', function(event) {
    let $parentDiv: JQuery<EventTarget> = $(event.target).closest('div.field_with_errors');
    $parentDiv.removeClass('field_with_errors');
    $parentDiv.next('.input-error-message').fadeOut(600);
});

$(document).on('turbo:load turbo:render', () => {
    let $searchSelectLabels: JQuery = $('.search-select-label');
    let $errorDivs = [];
    $searchSelectLabels.each((ind, el) => {
        let $el: JQuery = $(el);
        if ($el.parent().attr("class") == "field_with_errors"){
            $el.closest("select.search-select")
            $el.parent().parent().parent().next().find("select").on("change", ()=>{
                $el.parent().removeClass('field_with_errors');
                $el.parent().parent().parent().next().find(".input-error-message").fadeOut(600);
            });
            $el.parent().next().find("select").on("change", ()=>{
                $el.parent().removeClass('field_with_errors');
                $el.parent().next().find(".input-error-message").fadeOut(600);
            })
        }
    });
});

// $(document).on('turbo:load', () => {
//     let $lobbyistTrainingLabel = $('.lobbyist-training-label');
//     let $fieldWithErrorsDiv = $lobbyistTrainingLabel.parent()
//     if ($fieldWithErrorsDiv.attr("class") == 'field_with_errors'){
//         let $errorMessageDiv = $fieldWithErrorsDiv.next();
//         $("#lobbyist_registration_training_required_true, #trainingNotRequired").on("change", ()=>{
//             $errorMessageDiv.fadeOut(600, ()=>{
//                 $fieldWithErrorsDiv.removeClass('field_with_errors');
//             });
//
//         });
//     }
// });

$(document).on('turbo:load turbo:render', () => {
    let $lobbyingPeriodLabel = $('#lobbyingForEntireYear');
    if ($lobbyingPeriodLabel.next().attr("class") == 'input-error-message'){
        $("#lobbyist_registration_lobbying_for_entire_year_true, #lobbyist_registration_lobbying_for_entire_year_false ").on("change", ()=>{
            $lobbyingPeriodLabel.next(".input-error-message").fadeOut(600)
        });

    }
});

$(document).on('turbo:load turbo:render', () => {
    $('.datepicker').each((i, el)=>{
        let $el: JQuery = $(el);
        let $parentDiv = $el.parent()
        if ($parentDiv.attr("class") == "field_with_errors"){
            $el.on("change", ()=>{
                $parentDiv.parent().next(".input-error-message").fadeOut(600, ()=>{
                    $parentDiv.removeClass("field_with_errors");
                    $parentDiv.addClass("field_after_error_fix");

                    $parentDiv.parent().prev().removeClass("field_with_errors");
                });

            });
        }
    });
});


$(document).on('turbo:load turbo:render', () => {
    let $lobbyingPeriodLabel = $('.lobbying-type-label');
    if ($lobbyingPeriodLabel.parent().attr("class") == 'field_with_errors'){
        $("#lobbyist_registration_lobbying_type_legislative, #lobbyist_registration_lobbying_type_executive, #lobbyist_registration_lobbying_type_grassroots").on("change",()=>{
            $lobbyingPeriodLabel.parent().next(".input-error-message").fadeOut(600, ()=>{
                $lobbyingPeriodLabel.parent().removeClass("field_with_errors")
            })
        });
    }
});

$(document).on('turbo:load turbo:render', () => {
    $('.sponsor-info').each((i, el)=>{
        let $el: JQuery = $(el);
        let $parentDiv = $el.parent()
        if ($parentDiv.attr("class") == "field_with_errors"){
            $el.on("change", ()=>{
                let labelDiv = $(".sponsor-label");
                labelDiv.find("div.input-error-message").fadeOut(600, ()=>{
                labelDiv.find("div.field_with_errors").removeClass("field_with_errors");
                $parentDiv.removeClass("field_with_errors");
                })
            });
        }
    });
});
$(document).on('turbo:load turbo:render', () => {

    let $lobbyingForEntireYearLabel = $(".lobbying-for-entire-year-label");
    if ($lobbyingForEntireYearLabel.parent().attr("class") == "field_with_errors"){
        $("#lobbyist_registration_lobbying_year, #lobbyist_registration_lobbying_for_entire_year_true, #lobbyist_registration_lobbying_for_entire_year_false").on("change", ()=>{
            $lobbyingForEntireYearLabel.parent().removeClass("field_with_errors")
            $(".lobbying-period-questions").find("div.input-error-message").fadeOut()
        });
    }
});

//remove validation error for agency/board/office missing

$(document).on("turbo:load turbo:render", ()=> {
    let situationLabel = $(".situation-label");
    if (situationLabel.parent().attr("class") == "field_with_errors"){
        $(".situation").on("change", ()=>{
            situationLabel.parent().next().fadeOut( 600, ()=>{
                situationLabel.parent().removeClass("field_with_errors")
            })
        })
    }
});

$(document).on('turbo:load turbo:render', () => {
   $(".cu-datepicker").each((i, el) =>{
       let $el = $(el);
       if ($el.children("div.field_with_errors").length){
           $el.addClass("error-field");
           $el.find("input.datepicker").on("change", ()=>{
               $el.removeClass("error-field");
           })
       }
   })

});
